"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _variables = require("../variables");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            animation: ", " ", " ", " forwards;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            animation: ", " ", " ", " forwards;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getKeyframes = function getKeyframes(from, to, screenMargin, isReverse) {
  var marginTranslate = "translateX(".concat(+screenMargin, "px)");
  return "\n        from {\n            transform: translateX(".concat(isReverse ? to : from, ") ").concat(isReverse ? '' : marginTranslate, ";\n        }\n        \n        to {\n            transform: translateX(").concat(isReverse ? from : to, ") ").concat(isReverse ? marginTranslate : '', ";\n        }\n    ");
};

function _default(theme, props) {
  var _root;

  var _theme$palette = theme.palette,
      palette = _theme$palette === void 0 ? {} : _theme$palette,
      height = props.height,
      primary = props.primary,
      warning = props.warning,
      error = props.error,
      right = props.right,
      screenX = props.screenX,
      iconCommon = {
    width: theme.iconWidth,
    minWidth: theme.iconWidth,
    height: theme.iconHeight,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };
  var animationShow = theme.animationShow,
      // просто поменять свойство animationDirection с normal на reverse не прокатило :(
  animationHide = theme.animationHide,
      rootBackground = theme.background,
      iconBackground = theme.icon,
      positionKey = _variables.LEFT,
      transformFrom = '-100%',
      screenMargin = "-".concat(screenX);

  if (right) {
    positionKey = _variables.RIGHT;
    transformFrom = '100%';
    screenMargin = screenX;
  }

  if (!animationShow) {
    animationShow = (0, _styledComponents.keyframes)(_templateObject(), getKeyframes(transformFrom, 0, screenMargin));
  }

  if (!animationHide) {
    animationHide = (0, _styledComponents.keyframes)(_templateObject2(), getKeyframes(transformFrom, 0, screenMargin, true));
  }

  if (primary) {
    rootBackground = theme.backgroundPrimary;
    iconBackground = theme.iconPrimary;
  } else if (warning) {
    rootBackground = theme.backgroundWarning;
    iconBackground = theme.iconWarning;
  } else if (error) {
    rootBackground = theme.backgroundError;
    iconBackground = theme.iconError;
  }

  return {
    root: (_root = {
      position: 'fixed'
    }, (0, _defineProperty2["default"])(_root, positionKey, screenX), (0, _defineProperty2["default"])(_root, "borderRadius", theme.borderRadius), (0, _defineProperty2["default"])(_root, "maxWidth", theme.maxWidth), (0, _defineProperty2["default"])(_root, "width", theme.width), (0, _defineProperty2["default"])(_root, "boxShadow", theme.boxShadow), (0, _defineProperty2["default"])(_root, "color", theme.color), (0, _defineProperty2["default"])(_root, "display", 'flex'), (0, _defineProperty2["default"])(_root, "alignItems", 'center'), (0, _defineProperty2["default"])(_root, "paddingTop", theme.paddingTop), (0, _defineProperty2["default"])(_root, "paddingRight", theme.paddingRight), (0, _defineProperty2["default"])(_root, "paddingBottom", theme.paddingBottom), (0, _defineProperty2["default"])(_root, "paddingLeft", theme.paddingLeft), (0, _defineProperty2["default"])(_root, "fontSize", theme.fontSize), (0, _defineProperty2["default"])(_root, "lineHeight", theme.lineHeight), (0, _defineProperty2["default"])(_root, "background", rootBackground), (0, _defineProperty2["default"])(_root, "transitionProperty", 'position'), (0, _defineProperty2["default"])(_root, "transform", "translateX(".concat(transformFrom, ")")), (0, _defineProperty2["default"])(_root, "transition", height ? "".concat(theme.timingFunction, " ").concat(theme.duration) : 'none'), (0, _defineProperty2["default"])(_root, "zIndex", palette.zMaximal), _root),
    icon: _objectSpread({}, iconCommon, {
      marginRight: palette.gutter,
      background: iconBackground,
      alignSelf: 'flex-start'
    }),
    closeWrapper: {
      width: theme.iconWidth,
      height: theme.iconHeight,
      cursor: 'pointer',
      top: theme.closeIconTop,
      right: theme.closeIconRight
    },
    contentWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%'
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    animationShow: (0, _styledComponents.css)(_templateObject3(), animationShow, theme.duration, theme.timingFunction),
    animationHide: (0, _styledComponents.css)(_templateObject4(), animationHide, theme.duration, theme.timingFunction)
  };
}